import { createContext } from 'react'

import { AnalyticsContextType } from './types'

export const AnalyticsContext = createContext<AnalyticsContextType>({} as AnalyticsContextType)
